require('./home.less');
var ajax = require('@enhancer/fe-util-ajax');
var util = require('../../app/util');
var app = require('../../app/app');
var tpl = require('./home.html');
var locale = require('i18n');

$(document).ready(function() {
  ajax({
    url: '/api/userinfo'
  }, function(res) {
    if (res.success) {
      var data = {
        locale: locale(),
        domain0: location.hostname.match(/\w+\.\w+$/)
      };
      data.user = res.user;
      window.enhancerInitData = JSON.parse(JSON.stringify(res.user));
      data.user.create = util.format(data.user.created);
      data.user.last = util.format(data.user.last);
      data.user.avatar = res.user.avatar;



      data.pc = window.innerWidth > 640;
      data.active = data.user.status === 1;

      var selector = '';
      data.detailUrl = '//payment.' + data.domain0 + '/order-list';

      if (data.user.status !== 1) {
        selector = '.menu .user-profile';
        data.detailUrl = '//i.' + data.domain0 + '/detail';
      } else {
        var search = location.search.match(/to=([^&#]+)/);
        search = search ? search[1] : '';
        search = search || location.hash.substring(1);
        if (search) {
          var map = {
            profile: '//i.' + data.domain0 + '/detail',
            account: '//payment.' + data.domain0 + '/account',
            order: '//payment.' + data.domain0 + '/order-list',
            coupon: '//payment.' + data.domain0 + '/coupon-list'
          }
          if (map[search]) {
            selector = '.menu .user-' + search;
            data.detailUrl = map[search];
          }
        }
      }

      var html = tpl(data);
      $('body').append(html);

      if (selector) {
        $('.menu .selected').removeClass('selected');
        $(selector).addClass('selected');
      }

      var iframe = $('#detail');

      window.onhashchange = function change () {
        var hash = location.hash.substring(1);
        if (hash) {
          $('.menu a[data-hash="' + hash + '"]').click();
        }
      }

      $('.menu').on('click', '.open-link', function (e) {
        e.preventDefault();
        var current = $(e.currentTarget);
        var url = current.attr('href');
        var hash = current.data('hash');
        if (data.pc) {
            iframe.attr('src', url);
            location.hash = hash || '';
        } else {
          window.open(url);
        }
        if (data.pc) {
          $('.menu .selected').removeClass('selected');
          current.addClass('selected');
        }
      });
      var hash = location.hash.substring(1);
      hash && $('.menu a[data-hash="' + hash + '"]').click();
    } else {
      util.show(res.message, 'error');
    }
  });
});



// WEBPACK FOOTER //
// ./src/pages/home/home.js